import styled from 'styled-components';
import { colourPalette } from 'styles/styles';
export const HeyYabbleCountStepTableStyle = {
  Container: styled.div`
    margin-bottom: 40px;
    border: 1px solid ${colourPalette.neutral300};
  `,
};
